module.exports = __webpack_public_path__ + "media/images/athletes/1799-b657d8ed5ee95b0e8e5823c6b07684e2.png";